import '@backstage/cli/asset-types';
import '@deepc/ui/embedded-compiled.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { setupStatistics } from './statistics';
import { ModuleRegistry as AgGridModuleRegistry } from 'ag-grid-community';
import {
  LicenseManager,
  AllEnterpriseModule as AgGridAllEnterpriseModule,
} from 'ag-grid-enterprise';
import {
  ModuleRegistry,
  AllEnterpriseModule,
  LicenseManager as AgChartsLicenseManager,
} from 'ag-charts-enterprise';

const licenseKey = 'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-081710}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{deepc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{deepcos}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{deepcos}_need_to_be_licensed___{deepcos}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{14_October_2026}____[v3]_[0102]_MTc5MTkzMjQwMDAwMA==a5cf68214936ee37ec2b7d5b3fa59104';

// Set license for AG Grid
LicenseManager.setLicenseKey(licenseKey);
// Set license for AG Charts
AgChartsLicenseManager.setLicenseKey(licenseKey);
AgGridModuleRegistry.registerModules([AgGridAllEnterpriseModule]);
ModuleRegistry.registerModules([AllEnterpriseModule]);

setupStatistics();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
